import {getEmailTemplateByIdService} from '@/services/messageTemplatesService'
import {GetEmailTemplateByIdResponse} from '@/types/EmailTemplate'

export type GetEmailTemplateByIdUseCaseParams = {
  id: string
}

export async function getEmailTemplateByIdUseCase(
  {id}: GetEmailTemplateByIdUseCaseParams,
  signal?: AbortSignal
): Promise<GetEmailTemplateByIdResponse> {
  return getEmailTemplateByIdService(id, signal)
}
